import GameplayManager from "./GameplayManager";
import TuileDebugMouvement from './TuileDebugMouvement/TuileDebugMouvement';
import { CodeDeplacement } from '../../interfaces/ILabyData';
import TuileDebugDeclencheur from './TuileDebugDeclencheur/TuileDebugDeclencheur';
import { logReadableMatrice } from "./GameplayUtils";
import TuileDebugQuestion from './TuileDebugQuestion/TuileDebugQuestion';

export const renderTuilesDebugMouvement = (gpm:GameplayManager) => {    
    const urlParams = gpm.app.urlParams;
    if (!urlParams.debugmov) return null;    
    const matriceDeplacement = gpm.state.currentMatriceDeplacement;
    return (
        <>
        {
            
            matriceDeplacement.map((item,index)=>{
            return (
            <TuileDebugMouvement 
                gpl_manager={gpm}
                index={index}
                codeDeplacement={item as CodeDeplacement}
                key={`tuile_debug_n_${gpm.props.niveau}_${index}`}
                />
            )
        })
        
        }
        </>
    )
}
export const logTuilesDebugMouvement = (gpm:GameplayManager) => {
    if (gpm.tuilesDebugMouvDOM.current && gpm.tuilesDebugMouvDOM.current?.children){
        const lignes:any = {};
        const childs = gpm.tuilesDebugMouvDOM.current.children;
        const nbChild = childs.length;
        let curDiv:HTMLDivElement;
        let curLigne:string;
        let curColonne:string;
        let curCode:string;
        for (var c=0; c<nbChild; c++){
        curDiv = childs[c] as HTMLDivElement;
        curLigne = curDiv.getAttribute("data-ligne") as string;
        curColonne = curDiv.getAttribute("data-colonne") as string;
        curCode = curDiv.getAttribute("data-code") as string;
        if (!lignes["ligne"+curLigne]){
            lignes["ligne"+curLigne] = [];
            lignes["ligne"+curLigne][parseInt(curColonne)] = curCode;
        } else {
            lignes["ligne"+curLigne][parseInt(curColonne)] = curCode;
        }
        }
        console.log(lignes);
        let outputlog = "";
        Object.keys(lignes).forEach(item => {
        outputlog += "\n\""+item+"\":\"" + lignes[item].join("") + "\"," 
        })
        console.log(outputlog);
    }    
}



export const renderTuilesDebugDeclencheur = (gpm:GameplayManager) => {    
    const urlParams = gpm.app.urlParams;
    if (!urlParams.debugdecl) return null;    
    const matriceDeclencheur = gpm.state.currentMatriceDeclencheurs;
    return (
        <>
        {
            
            matriceDeclencheur.map((item,index)=>{
            return (
            <TuileDebugDeclencheur 
                gpl_manager={gpm}
                index={index}
                codeDeplacement={item as CodeDeplacement}
                key={`tuile_debug_n_${gpm.props.niveau}_${index}`}
                />
            )
        })
        
        }
        </>
    )
}


export const logTuilesDebugDeclencheurs = (gpm:GameplayManager) => {
    if (gpm.tuilesDebugDeclDOM.current && gpm.tuilesDebugDeclDOM.current?.children){
        const lignes:any = {};
        const childs = gpm.tuilesDebugDeclDOM.current.children;
        const nbChild = childs.length;
        let curDiv:HTMLDivElement;
        let curLigne:string;
        let curColonne:string;
        let curCode:string;
        for (var c=0; c<nbChild; c++){
        curDiv = childs[c] as HTMLDivElement;
        curLigne = curDiv.getAttribute("data-ligne") as string;
        curColonne = curDiv.getAttribute("data-colonne") as string;
        curCode = curDiv.getAttribute("data-code") as string;
        if (!lignes["ligne"+curLigne]){
            lignes["ligne"+curLigne] = [];
            lignes["ligne"+curLigne][parseInt(curColonne)] = curCode;
        } else {
            lignes["ligne"+curLigne][parseInt(curColonne)] = curCode;
        }
        }
        console.log(lignes);
        let outputlog = "";
        Object.keys(lignes).forEach(item => {
        outputlog += "\n\""+item+"\":\"" + lignes[item].join("") + "\"," 
        })
        console.log(outputlog);
        console.log("VS STATE = ");
        logReadableMatrice(gpm.state.currentMatriceDeclencheurs);
    }    
}



export const renderTuilesDebugQuestion = (gpm:GameplayManager) => {    
    const urlParams = gpm.app.urlParams;
    if (!urlParams.debugquest) return null;    
    const matriceQuestions = gpm.state.currentMatriceQuestions;
    return (
        <>
        {
            
            matriceQuestions.map((item,index)=>{
            return (
            <TuileDebugQuestion 
                gpl_manager={gpm}
                index={index}
                codeDeplacement={item as CodeDeplacement}
                key={`tuile_debug_n_${gpm.props.niveau}_${index}`}
                />
            )
        })
        
        }
        </>
    )
}

export const logTuilesDebugQuestions = (gpm:GameplayManager) => {
    if (gpm.tuilesDebugQuestDOM.current && gpm.tuilesDebugQuestDOM.current?.children){
        const lignes:any = {};
        const childs = gpm.tuilesDebugQuestDOM.current.children;
        const nbChild = childs.length;
        let curDiv:HTMLDivElement;
        let curLigne:string;
        let curColonne:string;
        let curCode:string;
        for (var c=0; c<nbChild; c++){
        curDiv = childs[c] as HTMLDivElement;
        curLigne = curDiv.getAttribute("data-ligne") as string;
        curColonne = curDiv.getAttribute("data-colonne") as string;
        curCode = curDiv.getAttribute("data-code") as string;
        if (!lignes["ligne"+curLigne]){
            lignes["ligne"+curLigne] = [];
            lignes["ligne"+curLigne][parseInt(curColonne)] = curCode;
        } else {
            lignes["ligne"+curLigne][parseInt(curColonne)] = curCode;
        }
        }
        console.log(lignes);
        let outputlog = "";
        Object.keys(lignes).forEach(item => {
        outputlog += "\n\""+item+"\":\"" + lignes[item].join("") + "\"," 
        })
        console.log(outputlog);
    }    
}